import { createFileRoute } from "@tanstack/react-router";
import SitePage from "@/components/SitePage";
import { buildHead, breadcrumbLD, touristTripLD, faqLD, SITE_URL } from "@/content/seo";

const TITLE = "Passeios de Barco em Quarteira · Iate Privado · Morningstar";
const DESC =
  "Passeios de barco privados a partir de Quarteira no Morningstar — Marina de Vilamoura a 5 minutos. Gruta de Benagil, cruzeiros pôr do sol e dia inteiro pelo Algarve, até 18 pessoas.";
const PATH = "/pt/passeios-de-barco-quarteira";
const URL = `${SITE_URL}${PATH}`;

export const Route = createFileRoute("/pt/passeios-de-barco-quarteira")({
  component: () => (
    <SitePage
      lang="pt"
      heroOverride={{
        eyebrow: "Passeios de Barco em Quarteira · Algarve",
        title: "Passeios de barco em Quarteira a bordo do ",
        titleAccent: "Morningstar.",
        sub: "Charter privado a 5 minutos de Quarteira — embarque na Marina de Vilamoura para grutas de Benagil, cruzeiros pôr do sol e dias inteiros no Algarve.",
        ctaPrimary: "Ver cruzeiros",
        ctaSecondary: "Planear o meu dia",
      }}
    />
  ),
  head: () =>
    buildHead({
      lang: "pt",
      path: PATH,
      title: TITLE,
      description: DESC,
      keywords:
        "passeios de barco Quarteira, aluguer barco Quarteira, charter iate Quarteira, Quarteira Benagil, cruzeiro Algarve Quarteira",
      altPath: { en: "/boat-trips-quarteira", pt: PATH },
      extraScripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(
            touristTripLD({
              name: "Passeios de barco privados a partir de Quarteira",
              description: DESC,
              url: URL,
              itinerary: "Marina de Vilamoura (5 min de Quarteira) → costa algarvia → paragem para mergulho → regresso.",
              durationHours: 4,
            }),
          ),
        },
        {
          type: "application/ld+json",
          children: JSON.stringify(
            breadcrumbLD([
              { name: "Início", path: "/pt" },
              { name: "Passeios de Barco Quarteira", path: PATH },
            ]),
          ),
        },
        { type: "application/ld+json", children: JSON.stringify(faqLD("pt")) },
      ],
    }),
});